<ul class="breadcrumb-list">
  <li>
    <a href="{{ controller }}">
      <nb-icon icon="home-outline"/>
    </a>
  </li>

  <li *ngFor="let breadCrumb of breadCrumbs | async">
    @if (breadCrumb.span) {
      <span>
        {{ breadCrumb.header }}
    </span>
    }

    @if (!breadCrumb.span) {
      <a [routerLink]="link(breadCrumb)" [queryParams]="params(breadCrumb)">
        {{ breadCrumb.header }}
      </a>
    }
  </li>
</ul>
